// ============================================================
// BARAKAH BUDGET — Full Redesign
// Clean overview landing → daily calendar view → all tools
// ============================================================

// ── GOOGLE FONT ──────────────────────────────────────────────
// Font is loaded in public/index.html — this is a no-op kept for import compatibility
const FontLink = () => null;

// ── THEME ────────────────────────────────────────────────────
const C = {
  bg:       "#0e0e13",
  surface:  "#16161e",
  surface2: "#1e1e28",
  surface3: "#252532",
  border:   "rgba(255,255,255,0.07)",
  border2:  "rgba(255,255,255,0.12)",
  text:     "#f0ede8",
  text2:    "#8a8a9a",
  text3:    "#555568",
  green:    "#3dd68c",
  greenDim: "rgba(61,214,140,0.12)",
  red:      "#f05252",
  redDim:   "rgba(240,82,82,0.1)",
  amber:    "#f5a623",
  amberDim: "rgba(245,166,35,0.1)",
  purple:   "#a78bfa",
  purpleDim:"rgba(167,139,250,0.1)",
  blue:     "#60a5fa",
  blueDim:  "rgba(96,165,250,0.1)",
  gold:     "#fbbf24",
};

// ── EXPENSE CATEGORIES ───────────────────────────────────────
const CATS = [
  { id:"Food",         icon:"🍔", color:"#f97316" },
  { id:"Groceries",    icon:"🛒", color:"#22c55e" },
  { id:"Transport",    icon:"🚗", color:"#3b82f6" },
  { id:"Rent",         icon:"🏠", color:"#8b5cf6" },
  { id:"Utilities",    icon:"💡", color:"#14b8a6" },
  { id:"Phone",        icon:"📱", color:"#0ea5e9" },
  { id:"Subscriptions",icon:"📺", color:"#ef4444" },
  { id:"Shopping",     icon:"🛍️", color:"#f59e0b" },
  { id:"Health",       icon:"💊", color:"#06b6d4" },
  { id:"Education",    icon:"🎓", color:"#6366f1" },
  { id:"Entertainment",icon:"🎮", color:"#d946ef" },
  { id:"Coffee",       icon:"☕", color:"#b45309" },
  { id:"Dining Out",   icon:"🍽️", color:"#f43f5e" },
  { id:"Investment",   icon:"📈", color:"#10b981" },
  { id:"Sadaqah",      icon:"🤲", color:"#4ade80" },
  { id:"Other",        icon:"📋", color:"#64748b" },
];
const getCat = id => CATS.find(c => c.id === id) || CATS[14];

const halalBucket = {
  Food:"Waste", Groceries:"Need", Transport:"Need", Rent:"Need",
  Utilities:"Need", Phone:"Want", Subscriptions:"Want", Shopping:"Want",
  Health:"Need", Education:"Need", Entertainment:"Want", Coffee:"Want",
  "Dining Out":"Want", Investment:"Need", Sadaqah:"Sadaqah", Other:"Want",
};

const DEBT_TYPES = [
  { id:"credit",   label:"Credit Card",  icon:"💳", color:"#f05252", haram:true  },
  { id:"mortgage", label:"Mortgage",     icon:"🏠", color:"#fb923c", haram:true  },
  { id:"car",      label:"Car Loan",     icon:"🚗", color:"#fbbf24", haram:true  },
  { id:"student",  label:"Student Loan", icon:"🎓", color:"#a78bfa", haram:true  },
  { id:"personal", label:"Personal Loan",icon:"👤", color:"#60a5fa", haram:true  },
  { id:"halal",    label:"Halal Finance",icon:"☪️", color:"#3dd68c", haram:false },
  { id:"family",   label:"Family/Friend",icon:"🤝", color:"#34d399", haram:false },
  { id:"other",    label:"Other",        icon:"📋", color:"#94a3b8", haram:false },
];
const getDebt = id => DEBT_TYPES.find(d => d.id === id) || DEBT_TYPES[7];

// ── HELPERS ──────────────────────────────────────────────────
// Currency — module-level ref updated by App on settings change
const CURRENCIES = [
  { code:"USD", symbol:"$",    label:"US Dollar" },
  { code:"CAD", symbol:"CA$",  label:"Canadian Dollar" },
  { code:"GBP", symbol:"£",    label:"British Pound" },
  { code:"EUR", symbol:"€",    label:"Euro" },
  { code:"INR", symbol:"₹",    label:"Indian Rupee" },
  { code:"MYR", symbol:"RM",   label:"Malaysian Ringgit" },
  { code:"AED", symbol:"AED",  label:"UAE Dirham" },
  { code:"SAR", symbol:"SAR",  label:"Saudi Riyal" },
  { code:"PKR", symbol:"₨",    label:"Pakistani Rupee" },
  { code:"BDT", symbol:"৳",    label:"Bangladeshi Taka" },
  { code:"IDR", symbol:"Rp",   label:"Indonesian Rupiah" },
  { code:"TRY", symbol:"₺",    label:"Turkish Lira" },
  { code:"NGN", symbol:"₦",    label:"Nigerian Naira" },
  { code:"EGP", symbol:"E£",   label:"Egyptian Pound" },
  { code:"KWD", symbol:"KD",   label:"Kuwaiti Dinar" },
  { code:"QAR", symbol:"QR",   label:"Qatari Riyal" },
  { code:"OMR", symbol:"OMR",  label:"Omani Rial" },
  { code:"BHD", symbol:"BD",   label:"Bahraini Dinar" },
  { code:"JOD", symbol:"JD",   label:"Jordanian Dinar" },
  { code:"MAD", symbol:"MAD",  label:"Moroccan Dirham" },
  { code:"TND", symbol:"DT",   label:"Tunisian Dinar" },
  { code:"SGD", symbol:"S$",   label:"Singapore Dollar" },
  { code:"AUD", symbol:"A$",   label:"Australian Dollar" },
  { code:"ZAR", symbol:"R",    label:"South African Rand" },
  { code:"GHS", symbol:"₵",    label:"Ghanaian Cedi" },
  { code:"KES", symbol:"KSh",  label:"Kenyan Shilling" },
];
let _currencySymbol = "CA$";
const setCurrencySymbol = s => { _currencySymbol = s; };
const fmt  = n => _currencySymbol + Math.abs(n).toLocaleString("en", { minimumFractionDigits:2, maximumFractionDigits:2 });
const fmtK = n => Math.abs(n) >= 1000 ? _currencySymbol + (Math.abs(n)/1000).toFixed(1) + "k" : _currencySymbol + Math.abs(n).toFixed(0);
const todayStr = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; };
const thisMonthStr = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`; };
const getDaysInMonth = (ym) => { const [y,m] = ym.split("-").map(Number); return new Date(y,m,0).getDate(); };
const getMonthLabel = (ym) => { const [y,m] = ym.split("-").map(Number); return new Date(y,m-1,1).toLocaleDateString("en",{month:"long",year:"numeric"}); };

function calcPayoff(balance, rate, payment) {
  if (balance <= 0) return 0;
  if (rate === 0) return payment > 0 ? Math.ceil(balance/payment) : Infinity;
  const r = rate/100/12;
  if (payment <= balance*r) return Infinity;
  return Math.ceil(-Math.log(1-(balance*r)/payment)/Math.log(1+r));
}

// ── STORAGE ──────────────────────────────────────────────────
// NEVER rename these keys. Users already have data stored under them.
// Renaming = silent data loss for every existing user. Add a new key instead.
const TX_KEY     = "bb_transactions_v1";
const DEBT_KEY   = "bb_debts_v1";
const RECUR_KEY  = "bb_recurring_v1";
const GOALS_KEY  = "bb_goals_v1";
const ZAKAT_KEY  = "bb_zakat_v1";
const NW_KEY      = "bb_networth_v1";
const SETTINGS_KEY = "bb_settings_v1";
const BUDGETS_KEY  = "bb_budgets_v1";

const load = (key, def) => { try { return JSON.parse(localStorage.getItem(key) || "null") ?? def; } catch { return def; } };
const save = (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} };

// ── AI ───────────────────────────────────────────────────────

const RECUR_STATUS_KEY = 'bb_recur_status_v1';
export { FontLink, C, CATS, getCat, halalBucket, DEBT_TYPES, getDebt, CURRENCIES, setCurrencySymbol, fmt, fmtK, todayStr, thisMonthStr, getDaysInMonth, getMonthLabel, calcPayoff, TX_KEY, DEBT_KEY, RECUR_KEY, GOALS_KEY, ZAKAT_KEY, NW_KEY, SETTINGS_KEY, BUDGETS_KEY, RECUR_STATUS_KEY, load, save };